import { TriangleAlert, LockKeyhole } from "lucide-react";
import Loader from "./Loader";
import React, { useState } from "react";

export default function SellPlayersModal({ ownedPlayers, onClose, onSell, isSelling, isMatchupsLive }) {
  const [confirmPlayer, setConfirmPlayer] = useState(null);

  const handleSellClick = (op) => {
    const locked = op.is_starter && isMatchupsLive;
    if (locked) return; // shouldn't happen, button is disabled

    if (op.is_starter) {
      // Show confirm modal
      setConfirmPlayer(op);
    } else {
      onSell(op);
    }
  };

  const handleConfirm = () => {
    if (confirmPlayer) {
      onSell(confirmPlayer);
      setConfirmPlayer(null);
    }
  };
  const handleCancel = () => setConfirmPlayer(null);
  return (
    <div className="market-modal-overlay" onClick={onClose}>
      <div className="market-modal" onClick={(e) => e.stopPropagation()} style={{ overflow: "auto", width: "95%" }}>
        <div className="market-modal-header">
          <div>
            <span className="market-modal-eyebrow">TEAM MANAGEMENT</span>
            <h3>Sell Players</h3>
            <p>Replace the players in your team.</p>
          </div>

          <button className="market-modal-close" onClick={onClose} aria-label="Close role selector">
            ×
          </button>
        </div>
        <p>Starter players are only available to sell between matchup weeks</p>
        <div className="modal-body">
          {ownedPlayers.length === 0 && <p style={{ color: "#aaa" }}>You don’t own any players.</p>}
          {isSelling && (
            <>
              <div className="modal-overlay">
                <Loader loadingTitle="Processing sale... updating market." showLogo />
              </div>
            </>
          )}
          <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexDirection: "column" }}>
            {ownedPlayers.map((op) => {
              const player = op.players;
              const locked = op.is_starter && isMatchupsLive;
              return (
                <div
                  key={op.id}
                  className={`sell-row`}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexDirection: "row",
                    width: "100%",
                    opacity: isSelling ? 0.6 : 1,
                    pointerEvents: isSelling ? "none" : "auto",
                  }}>
                  <div style={{ display: "flex", gap: 10 }}>
                    <img
                      src={`/players/${player.player_image}`}
                      alt={player.name}
                      style={{ border: "none", background: "none", height: "136px", objectFit: "contain", marginBottom: "10px" }}
                    />
                    <div style={{ display: "flex", flexDirection: "column" }}>
                      <span style={{ display: "flex", gap: "10px", alignItems: "flex-start", flexDirection: "column" }}>
                        <div style={{ display: "flex", alignItems: "flex-start", gap: "2px", flexDirection: "column" }}>
                          <div style={{ display: "flex", flexDirection: "row", gap: "2px", alignItems: "center" }}>
                            <img
                              src={`/teams/${player.teams.team_logo}`}
                              alt={player.teams.name}
                              style={{ border: "none", background: "none", width: "20px", height: "20px", objectFit: "contain" }}
                            />
                            <p className="tooltip-title" style={{ margin: "0", color: "white", fontSize: "14px" }}>
                              {player.name}
                            </p>
                          </div>
                          <p style={{ margin: "0", color: "rgb(255 255 255 / 60%)", fontSize: "10px" }}>
                            {player.role} | <b>{player.teams.name}</b>
                          </p>
                        </div>
                      </span>
                      <div className="sell-price">
                        <div style={{ display: "flex", alignItems: " center", gap: 2, marginTop: 10 }}>
                          <img src="/league-coin.png" className="coin" alt="League Coin" />
                          <h4>{player.dynamic_price.toLocaleString()}</h4>
                        </div>
                        <p style={{ fontSize: "12px", opacity: "0.6" }}>Original: {player.price.toLocaleString()}</p>
                      </div>
                    </div>
                  </div>
                  <button disabled={locked || isSelling} className="edit-btn" onClick={() => handleSellClick(op)}>
                    {locked ? (
                      <div style={{ display: "flex", alignItems: "center", fontSize: "14px", gap: 4 }}>
                        <LockKeyhole size={16} />
                        Starter
                      </div>
                    ) : (
                      "Sell"
                    )}
                  </button>
                </div>
              );
            })}
          </div>
        </div>
      </div>
      {confirmPlayer && (
        <div className="market-modal-overlay" onClick={handleCancel}>
          <div className="market-modal" onClick={(e) => e.stopPropagation()} style={{ width: "400px", textAlign: "center" }}>
            <TriangleAlert size={52} />
            <h2 style={{ marginTop: 0 }}>Are you sure?</h2>
            <p style={{ color: "rgb(255 192 80)" }}>This player is a starter on your team</p>
            <p>
              Are you sure you want to sell <b>{confirmPlayer.players.name}</b>?
            </p>
            <div style={{ display: "flex", justifyContent: "center", gap: 10, marginTop: 20 }}>
              <button
                style={{
                  background: "rgba(255, 255, 255, 0.1)",
                  border: "1px solid rgba(255, 255, 255, 0.14)",
                  color: "white",
                  boxShadow: "none",
                  padding: "12px 32px",
                  cursor: "pointer",
                }}
                className="edit-btn"
                onClick={handleCancel}>
                Cancel
              </button>
              <button className="edit-btn" onClick={handleConfirm}>
                Yes, Sell
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
